import { css } from 'lit-element/lit-element';
import KiSwitcher from '@giswebgroup/ki-wcp-base/src/components/ki-switcher/ki-switcher';
import LoaderMixin from '@giswebgroup/ki-wcp-base/src/common/LoaderMixin';

export default class Switcher extends LoaderMixin(KiSwitcher) {
  static get styles() {
    return [
      super.styles,
      css`
        :host {
          display: inline-flex;
          border-radius: 0px;
          overflow: hidden;
          font-size: 0px;


        }

        .tab {
          border: 1px solid var(--theme-color, #0056a0);
          font-size: 12px;
          padding: 6px 5px 5px 5px;
          min-width: 91px;
        }
      `,
    ];
  }
}

customElements.define('x-switcher', Switcher);
